import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import React from 'react';
import ProductsCarousel from '../ProductsCarousel';

const Container = styled('div')`
  border: 0px;
  padding: 0;
  display: inline-block;
  width: 100%;

  h2 {
    margin-top: 4rem;
  }
`;

export const RelatedProductsContainer = ({ relatedProducts, loading }) => (
  <Container>
    <h2>{t('Related products')}</h2>
    <ProductsCarousel products={relatedProducts} isLoading={loading} />
  </Container>
);

export default RelatedProductsContainer;
